import SessionService from '@/services/session.service.js'

import {
  GET_SESSION_KEY,
  CLEAR_SESSION,  
  CHECK_SESSION,  
} from "../actions.type";
import { 
  SET_SESSION_KEY, 
  PURGE_SESSION_KEY, 
  SET_ERROR,
  IS_LOADING
} from "../mutations.type";

const state = {
  isLoading: false,
  session_key: "",  
  isValidSession: null,
  errors: []
};

const getters = {
  currentSession(state) {
    return state.session_key;
  },
  isValidSession(state) {
    return state.isValidSession;
  }
};

const actions = {
  [GET_SESSION_KEY](context) {
    context.commit(IS_LOADING, true);
    return SessionService.getSession()
      .then(({ data }) => {
        if(data.success) {
          context.commit(SET_SESSION_KEY, data.data.session);
        } else {
          context.commit(SET_ERROR, data.data.errors);
        }
        context.commit(IS_LOADING, false);
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response);
        context.commit(IS_LOADING, false);
      });
  },
  [CLEAR_SESSION](context) {
    context.commit(PURGE_SESSION_KEY);
  },
  [CHECK_SESSION]() {
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.errors = typeof(errors) != undefined ? errors : [];
    state.isValidSession = false;
  },
  [SET_SESSION_KEY](state, session_key) {
    state.isValidSession = true;
    state.session_key = session_key;
    state.errors = {};
  },
  [PURGE_SESSION_KEY](state) {
    state.isValidSession = false;
    state.session_key = null;
    state.errors = {};    
  },
  [IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;  
  }
};

export default {  
  state,  
  getters,
  actions,
  mutations
}